/* eslint max-len: 0 */
/* eslint jsx-a11y/click-events-have-key-events: 0 */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { getMeilleursComp } from 'redux/meilleursCompetition/meilleursCompSlice';
import { getTournamentMatches } from 'redux/tournament-matches/tournamentMatchesSlice';
import { getCategoryTournaments, selectTournament } from 'redux/category-tournaments/categoryTournamentsSlice';
import { getAllSports, selectSport } from 'redux/all-sports/allSportsSLice';
import '../../../styles/_dashboard.scss';
import { getCategories } from 'redux/categories/categoriesSlice';
import translationKeys from 'translations/translationKeys';
import { getTomatchesMkts } from 'redux/meilleursParis/topmatchesMktsSlice';
import PropTypes from 'prop-types';
import { resetHeader, setTournament } from 'redux/nav-header/navHeader';
import { getClientBonus } from 'redux/client-bonus/clientBonusSlice';
import getLocalStorageValue from 'components/helpers/parseJson';
import Loading from 'components/common/Loading';
import { CRUMB_TYPE } from 'utils/utils';
import {
  clearCrumbs, setCrumbs,
} from 'redux/nav-breadcrumbs/navBreadcrumbsSlice';
import fire from '../../../assets/images/mathys/svg/fire.svg';
import circle from '../../../assets/images/mathys/svg/play-circle.svg';
import camera from '../../../assets/images/mathys/svg/camera-reels.svg';
import arrowRight from '../../../assets/images/mathys/svg/arrow-right.svg';
import sportImage from '../../../assets/images/mathys/png/sport.png';
import homeImage from '../../../assets/images/mathys/svg/house.svg';
import defaultImage from '../../../assets/images/mathys/png/football.png';
import crossImage from '../../../assets/images/mathys/svg/x-lg.svg';
import backIcon from '../../../assets/images/mathys/svg/chevron-left.svg';
import forwardIcon from '../../../assets/images/mathys/svg/chevron-right.svg';
import burgerImage from '../../../assets/images/mathys/svg/burger.svg';
import baseUrls from '../../../config';

const LeftSideBar = ({ isMobile, openMobileBetSlip }) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const imgUrl = baseUrls.BASE_URL_IMG;
  const dispatch = useDispatch();

  const [className, setClassName] = useState('sub-menu hide-sub-menu');
  const [tClassName, setTClassName] = useState('tournament');
  const [openItemId, setOpenItemId] = useState(null);
  const [menuToggle, setMenuToggle] = useState(false);
  const [text, setText] = useState(getLocalStorageValue('text'));
  const [buttonId, setButtonId] = useState(getLocalStorageValue('buttonId'));
  const [activeSportId, setActiveSportId] = useState(null);
  const [activeSportName, setActiveSportName] = useState(null);
  const [activeCategoryId, setActiveCategoryId] = useState(null);

  const { allSports } = useSelector((store) => store.allSports);
  const { meilleursComp } = useSelector((store) => store.meilleursComp);
  const { categories } = useSelector((store) => store.categories);
  const { tournaments } = useSelector((store) => store.tournaments);
  const { meilleursParis } = useSelector((store) => store.meilleursParis);
  const { cleanedMarkets } = useSelector((store) => store.topMatchesMkts);
  const { lang } = useSelector((store) => store.language);
  const { agentId } = useSelector((store) => store.login);
  const { bets } = useSelector((store) => store.betSlip);
  const { homeList } = useSelector((store) => store.homeList);
  const { pendingCrumbClick } = useSelector((store) => store.navBreadcrumb);

  const {
    msg11, msg10, msg9, msg12, msg13, msg153,
  } = translationKeys;

  // Stable list/links — defined once, not recreated every render via uuidv4
  const list = [
    {
      id: 'list-meilleurs-paris', img: fire, path: 'meilleurs-paris', text: msg9,
    },
    {
      id: 'list-today-matches', img: circle, path: 'today-matches', text: msg10,
    },
    {
      id: 'list-meilleures-comp', img: camera, text: msg11, path: pathname, className: 'normal',
    },
  ];

  const links = [
    {
      id: 'link-sports', path: 'meilleurs-paris', text: msg13, img: sportImage, className: 'btn btn-secondary show-sports-memu',
    },
    {
      id: 'link-home', path: 'home', text: msg12, img: homeImage, className: 'btn btn-secondary',
    },
  ];

  // ─── UI helpers ────────────────────────────────────────────────────────────

  const activeSport = (path) => pathname.includes('match') && path === 'meilleurs-paris';
  const activeDashBoard = (path) => homeList.some((homeLink) => pathname.includes(homeLink.code)) && path === 'home';

  const hideSideBar = () => {
    setClassName('sub-menu hide-sub-menu');
    setTClassName('tournament');
    setMenuToggle(false);
  };

  const showSideBar = () => {
    setClassName('sub-menu');
    setTClassName('tournament');
  };

  const clearAllMenus = () => {
    setClassName('sub-menu hide-sub-menu');
    setTClassName('tournament');
  };

  const toggleAcc = (itemId) => {
    setOpenItemId((prev) => (prev === itemId ? null : itemId));
  };

  const toggleTournamentsBar = (toggle) => {
    if (toggle) {
      setTClassName('tournament expand');
      setClassName('sub-menu');
    } else {
      showSideBar();
    }
  };

  const updateTextAndButtonId = (value) => {
    setButtonId(value);
    setText(value);
    localStorage.setItem('text', value);
    localStorage.setItem('buttonId', value);
  };

  // Builds the full breadcrumb trail in one shot — called only when an
  // end-navigation (tournament) is selected. Crumbs are only ever
  // cleared/replaced here.
  const buildFullCrumbTrail = ({
    navLabel, sport, category, tournament,
  }) => {
    const crumbs = [{
      id: `nav-${navLabel.split(' ').join('-')}`, type: CRUMB_TYPE.LABEL, label: navLabel, path: null,
    }];

    if (sport) {
      crumbs.push({
        id: `sport-${sport.id}`, type: CRUMB_TYPE.SPORT, label: sport.name, sportId: sport.id,
      });
    }

    if (category) {
      crumbs.push({
        id: `cat-${category.id}`, type: CRUMB_TYPE.CATEGORY, label: category.name, categoryId: category.id,
      });
    }

    crumbs.push({
      id: `trn-${tournament.id}`, type: CRUMB_TYPE.TOURNAMENT, label: tournament.name, tournamentId: tournament.id,
    });

    dispatch(clearCrumbs());
    dispatch(setCrumbs(crumbs));
  };

  // ─── breadcrumb click handler ──────────────────────────────────────────────

  const handleCrumbClick = (crumb) => {
    switch (crumb.type) {
      case CRUMB_TYPE.NAV:
        if (crumb.path) navigate(crumb.path);
        if (crumb.openSideBar) {
          toggleTournamentsBar(true);
        } else {
          hideSideBar();
        }
        setActiveSportId(null);
        setActiveSportName(null);
        setActiveCategoryId(null);
        dispatch(clearCrumbs());
        dispatch(setCrumbs([{
          id: `nav-${crumb.label}`,
          type: CRUMB_TYPE.NAV,
          label: crumb.label,
          path: crumb.path,
          openSideBar: crumb.openSideBar,
        }]));
        break;

      case CRUMB_TYPE.SPORT:
        if (crumb.sportId !== activeSportId) {
          dispatch(selectSport(crumb.sportId));
          dispatch(getCategories(crumb.sportId));
        }
        setActiveSportId(crumb.sportId);
        setActiveSportName(crumb.label);
        setActiveCategoryId(null);
        setOpenItemId(null);
        updateTextAndButtonId(crumb.label);
        toggleTournamentsBar(true);
        break;

      case CRUMB_TYPE.CATEGORY:
        if (crumb.categoryId !== activeCategoryId) {
          dispatch(getCategoryTournaments(crumb.categoryId));
        }
        setActiveCategoryId(crumb.categoryId);
        setOpenItemId(crumb.categoryId);
        toggleTournamentsBar(true);
        break;

      case CRUMB_TYPE.TOURNAMENT:
        navigate('/dashboard/matches');
        break;

      default:
        break;
    }
  };

  // ─── effects ──────────────────────────────────────────────────────────────

  // Pending crumb click from NavigationBreadcrumb via Redux
  useEffect(() => {
    if (pendingCrumbClick) {
      handleCrumbClick(pendingCrumbClick.crumb, pendingCrumbClick.index);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingCrumbClick]);

  // Sidebar visibility, sports fetch, and market init based on route
  useEffect(() => {
    if (pathname.includes('match') || pathname.includes('paris')) {
      dispatch(getAllSports());
      if (pathname.includes('paris')) {
        setButtonId(msg9);
        setText(msg9);
      }
      if (!isMobile) showSideBar();
    } else {
      if (pathname.includes('home') && isMobile) dispatch(resetHeader());
      if (!isMobile) hideSideBar();
    }

    if (Object.keys(cleanedMarkets).length < 1) {
      dispatch(getTomatchesMkts());
    }
  // cleanedMarkets intentionally omitted — only re-run on route/lang/mobile changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, pathname, isMobile, lang]);

  // Seed top sport from first meilleurs paris entry
  useEffect(() => {
    if (meilleursParis.length > 0 && !localStorage.getItem('topSportSelected')) {
      localStorage.setItem('topSportSelected', meilleursParis[0].id);
    }
  }, [meilleursParis]);

  // Fetch client bonus when agent ID becomes available
  useEffect(() => {
    if (agentId?.length > 0) {
      dispatch(getClientBonus(agentId));
    }
  }, [agentId, dispatch]);

  // Restore sidebar on language change when menu was open (desktop)
  useEffect(() => {
    if (!isMobile && menuToggle) showSideBar();
  }, [lang, isMobile, menuToggle]);

  // Fetch competitions and re-fetch open category tournaments on lang change
  useEffect(() => {
    dispatch(getMeilleursComp());
    if (openItemId) dispatch(getCategoryTournaments(openItemId));
  }, [lang, dispatch]);

  // Re-fetch tournaments when a category accordion is opened
  useEffect(() => {
    if (openItemId) dispatch(getCategoryTournaments(openItemId));
  }, [openItemId, dispatch]);

  // ─── render ────────────────────────────────────────────────────────────────

  return (
    <div className="sidebar">
      {isMobile && (
        <div className="bottom-selections">
          <button className="menu-toggler" type="button" onClick={() => setMenuToggle(!menuToggle)}>
            <span style={{ maskImage: `url(${menuToggle ? crossImage : burgerImage})` }} className="icon" />
            <span className="title">Menu</span>
          </button>
          <button className="betslip-toggler" type="button" onClick={openMobileBetSlip}>
            <span className="number-selection title">{bets.length}</span>
            <span className="title">{t(msg153)}</span>
          </button>
        </div>
      )}

      <div className={`group-btn ${menuToggle ? 'up' : ''}`}>
        {links.map((link) => link && (!isMobile || link.path !== 'home') && (
          <NavLink
            to={link.path}
            key={link.id}
            className={({ isActive }) => (isActive || activeSport(link.path) || activeDashBoard(link.path) ? `${link.className} selected` : link.className)}
            onClick={() => {
              localStorage.setItem('activeSideMenu', JSON.stringify(link.text));
              if (link.path.includes('paris') && isMobile) showSideBar();
              dispatch(clearCrumbs());
            }}
          >
            <img src={link.img} alt="" />
            <span className="title">{t(link.text)}</span>
          </NavLink>
        ))}
      </div>

      <div className={className} id="sub-menu">
        <div className="content-sub-menu">
          <div className="content-sport">
            <ul className="tab-list">
              {isMobile && (
                <li key="sport-title">
                  <NavLink
                    className="title"
                    to="home"
                    onClick={() => {
                      if (isMobile) { hideSideBar(); dispatch(clearCrumbs()); }
                    }}
                  >
                    <button className="btn btn-nav" type="button">
                      <img src={backIcon} alt="menu" />
                    </button>
                    <span>SPORTS</span>
                  </NavLink>
                </li>
              )}

              {list.map((item) => (
                <li key={item.id}>
                  <button
                    type="button"
                    className={(buttonId === item.text && !isMobile) ? 'btn normal selected' : 'btn normal'}
                    onClick={() => {
                      updateTextAndButtonId(item.text);

                      if (item.path === 'today-matches') {
                        // Old behaviour: navigate directly, no sport sub-panel
                        dispatch(setTournament({ name: item.text, redirect: 'home' }));
                        navigate(item.path);
                        if (isMobile) hideSideBar();
                        else toggleTournamentsBar(false);
                        dispatch(clearCrumbs());
                      } else if (item.path === pathname) {
                        // Meilleures Compétitions — stay on current path, open panel
                        dispatch(getMeilleursComp());
                        toggleTournamentsBar(true);
                        dispatch(clearCrumbs());
                      } else {
                        dispatch(setTournament({ name: item.text, redirect: 'home' }));
                        navigate(item.path);
                        if (isMobile) hideSideBar();
                        else toggleTournamentsBar(false);
                        dispatch(clearCrumbs());
                      }
                    }}
                  >
                    <img src={item.img} alt="" />
                    <span>{t(item.text)}</span>
                    {isMobile && <img src={forwardIcon} alt="navigate" className="btn-nav" />}
                  </button>
                </li>
              ))}

              {allSports?.length > 0 && allSports.map((item) => item && (
                <li key={item.id}>
                  <button
                    type="button"
                    className={(buttonId === item.name && !isMobile) ? 'btn normal selected' : 'btn normal'}
                    onClick={() => {
                      dispatch(selectSport(item.id));
                      dispatch(getCategories(item.id));
                      toggleTournamentsBar(true);
                      updateTextAndButtonId(item.name);
                      setActiveSportId(item.id);
                      setActiveSportName(item.name);
                      setActiveCategoryId(null);
                      setOpenItemId(null);
                    }}
                  >
                    <img src={item.icon ? imgUrl + item.icon : defaultImage} alt="" />
                    <span>{item.name}</span>
                    {isMobile && <img src={forwardIcon} alt="navigate" className="btn-nav" />}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className={tClassName}>
            <div
              className="navs top-event title"
              onClick={() => isMobile && toggleTournamentsBar(false)}
            >
              {isMobile && (
                <button className="btn btn-nav" type="button">
                  <img src={backIcon} alt="menu" />
                </button>
              )}
              <span>{text === 'Meilleures Compétitions' ? t(msg11) : text}</span>
              {!isMobile && (
                <div className="close-tab">
                  <button type="button" id="major-tournaments" className="btn" onClick={showSideBar}>
                    <img src={crossImage} alt="x" className="icon" />
                  </button>
                </div>
              )}
            </div>

            <ul className="list-unstyled">
              {(text === 'Meilleures Compétitions') && meilleursComp?.length > 0 && (
                meilleursComp.map((m) => (
                  <li key={m.id}>
                    <NavLink
                      className="navs"
                      to="/dashboard/matches"
                      onClick={() => {
                        dispatch(getTournamentMatches({ tournamentId: m.id }));
                        localStorage.setItem('tournamentId', JSON.stringify(m.id));
                        dispatch(setTournament({ name: m.name, redirect: 'home' }));
                        buildFullCrumbTrail({
                          navLabel: t(msg11),
                          sport: null,
                          category: null,
                          tournament: { id: m.id, name: m.name },
                        });
                        if (!isMobile) showSideBar();
                        else clearAllMenus();
                      }}
                    >
                      <span>{m.name}</span>
                      <img src={isMobile ? forwardIcon : arrowRight} alt="" />
                    </NavLink>
                  </li>
                ))
              )}

              {text !== 'Meilleures Compétitions' && categories.isLoading && (
                <div className="mt-4"><Loading /></div>
              )}

              {text !== 'Meilleures Compétitions' && !categories.isLoading && (
                categories.data?.length > 0 && categories.data.map((item) => item && (
                  <div key={item.id} className={`cat-cont ${openItemId === item.id ? 'active' : ''}`}>
                    <button
                      type="button"
                      className="navs tnmt-btn"
                      onClick={() => {
                        dispatch(getCategoryTournaments(item.id));
                        toggleAcc(item.id);
                        setActiveCategoryId(item.id);
                      }}
                    >
                      <span>{item.name}</span>
                      {isMobile && (
                        <img src={forwardIcon} alt="" className={`arrow-icon ${openItemId !== item.id ? '' : 'rotate'}`} />
                      )}
                    </button>
                    {tournaments.categoryId === item.id && (
                      <div className={`openAcc${openItemId === item.id ? '' : ' closed'}`}>
                        {tournaments?.tournaments?.length > 0 && tournaments.tournaments.map((tour) => tour && (
                          <NavLink
                            className="navs sub"
                            key={tour.id}
                            to="/dashboard/matches"
                            onClick={() => {
                              dispatch(selectTournament(tour));
                              dispatch(getTournamentMatches({ tournamentId: tour.id }));
                              localStorage.setItem('tournamentId', JSON.stringify(tour.id));
                              dispatch(setTournament({ name: `${item.name} - ${tour.name}`, redirect: 'home' }));
                              buildFullCrumbTrail({
                                navLabel: t(msg13),
                                sport: activeSportId ? { id: activeSportId, name: activeSportName } : null,
                                category: { id: item.id, name: item.name },
                                tournament: { id: tour.id, name: tour.name },
                              });
                              if (!isMobile) showSideBar();
                              else clearAllMenus();
                            }}
                          >
                            <span>{tour.name}</span>
                            <img src={isMobile ? forwardIcon : arrowRight} alt="" />
                          </NavLink>
                        ))}
                      </div>
                    )}
                  </div>
                ))
              )}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

LeftSideBar.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  openMobileBetSlip: PropTypes.func.isRequired,
};

export default LeftSideBar;
